// src/utils/encryptionService.ts
import CryptoJS from "crypto-js";

export class EncryptionService {
  private static readonly encryptionKey: string = "RArKI$B_RUhp2V7S"; // Replace with your 16-character key

  private static getKey() {
    return CryptoJS.enc.Utf8.parse(this.encryptionKey);
  }

  private static getIV() {
    return CryptoJS.enc.Utf8.parse("\0".repeat(16)); // 16 bytes of zeros
  }

  static encrypt(plainText: string): string {
    const key = this.getKey();
    const iv = this.getIV();
    const encrypted = CryptoJS.AES.encrypt(plainText, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  static decrypt(encryptedText: string): string {
    const key = this.getKey();
    const iv = this.getIV();
    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
